<template>
  <div class="-mx-3 py-2 px-4 bg-blue-400 flex justify-between items-center lg:mx-0">
    <div class="flex items-center gap-4">
      <p class="w-max border border-blue-400 rounded-xl px-3 bg-white text-sm text-blue-400 leading-6 hidden lg:block">{{ $t("testBank.limit") }}</p>
      <div class="flex items-center">
        <div class="flex items-center">
          <GrmTextField type="number" textalign="right" size="2xs" :min="0" :max="23" class="w-14 mr-1 flex" v-model="hours" />
          <p class="text-sm text-white">{{ $t('common.hour') }}</p>
        </div>
        <div class="ml-3 flex items-center">
          <GrmTextField type="number" textalign="right" size="2xs" :min="0" :max="59" class="w-14 mr-1 flex" v-model="minutes" />
          <p class="text-sm text-white">{{ $t('common.minute') }}</p>
        </div>
        <div class="ml-3 flex items-center">
          <GrmTextField type="number" textalign="right" size="2xs" :min="0" :max="59" class="w-14 mr-1 flex" v-model="seconds" />
          <p class="text-sm text-white">{{ $t('common.second') }}</p>
        </div>
      </div>
    </div>
    <GrmBtn @click="onStartExam">{{ $t("common.start") }}</GrmBtn>
  </div>
</template>

<script>
import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'TestbankInfoFooter',
  components: {
    GrmTextField,
    GrmBtn
  },
  data() {
    return {
      hours: 0,
      minutes: 30,
      seconds: 0,
    }
  },
  computed: {
    ...mapGetters('room',[
        'isRoomMode'
    ])
  },
  methods: {
    ...mapActions('exam', [
      'startExam',
    ]),

    onStartExam() {
      if(this.isRoomMode('group')) {
        this.$alert(this.$t('testBank.alert.disableInGroup'))
        return;
      }
      this.$alert({
        text: this.$t('testBank.alert.checkStart'),
        ok: async () => {
          try {
            const examDuration = this.hours * 60 * 60 + this.minutes * 60 + this.seconds;
            await this.startExam({ examDuration });
            this.$modal('Testbank');
          } catch (e) {
            switch (e.message) {
              case 'EXAM_ALREADY_STARTED':
                this.$alert(this.$t('testBank.alert.alreadyStarted'));
                break;
              default:
                this.$alert(this.$t('testBank.alert.writeFail'));
                break;
            }
          }        }
      })
    },
  }
}
</script>